angular
    .module('festzelt-os.modules.messages', []);

require('./routes');

require('./factories/message-factory');
require('./factories/sms-template-factory');
require('./store/messages');
require('./store/sms-templates');
require('./workflows');



// WEBPACK FOOTER //
// ./src/app/modules/messages/module.js